export const menu = [
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Pagine'
    },
    {
        "type": 'item',
        "href": '/',
        "icon": 'home',
        "entity": '',
        "label": 'Dashboard'
    },
    {
        "type": 'item',
        "href": '/page/SearchItem',
        "icon": 'search',
        "entity": 'gyv_item',
        "label": 'Ricerca articoli'
    },
    {
        "type": 'item',
        "href": '/page/Cart',
        "icon": 'cart-shopping',
        "entity": 'gyv_item',
        "label": 'Carrello'
    },
    {
        "type": 'item',
        "href": '/page/OrderImport',
        "icon": 'file-excel',
        "entity": 'gyv_item',
        "label": 'Importa ordine da Excel'
    },
    {
        "type": 'item',
        "href": '/page/OrderInProgress',
        "icon": 'folder-open',
        "entity": 'gyv_order',
        "label": 'Ordini in compilazione',
        "hideForLevel": [2]
    },
    {
        "type": 'item',
        "href": '/page/OrderToAccept',
        "icon": 'folder-open',
        "entity": 'gyv_order',
        "label": 'Ordini in accettazione',
        "hideForLevel": [2]
    },
    {
        "type": 'item',
        "href": '/page/OrderToApprove',
        "icon": 'folder-open',
        "entity": 'gyv_order',
        "label": 'Ordini in approvazione',
        "hideForLevel": [1, 2]
    },
    {
        "type": 'item',
        "href": '/entity/gyv_order',
        "icon": 'folder-open',
        "entity": 'gyv_order',
        "label": 'Status ordini'
    },
    /*
    {
        "type": 'item',
        "href": '/entity/gyv_customer_history',
        "icon": 'folder',
        "entity": 'gyv_customer_history',
        "label": 'Storico acquisti clienti'
    },
    */
    {
        "type": 'item',
        "href": '/entity/gyv_customer_active',
        "icon": 'users',
        "entity": 'gyv_customer_active',
        "label": 'Clienti attivi'
    },
    {
        "type": 'item',
        "href": '/entity/gyv_customer_unsolved',
        "icon": 'user-xmark',
        "entity": 'gyv_customer_unsolved',
        "label": 'Clienti insoluti'
    },
    {
        "type": 'item',
        "href": '/page/CustomerDetails',
        "icon": 'user',
        "entity": 'gyv_customer',
        "label": 'Dettaglio cliente',
        "hideForLevel": [0, 1]
    },
    {
        "type": 'item',
        "href": '/page/Catalogue',
        "icon": 'book',
        "label": 'Cataloghi'
    },
    {
        "type": 'item',
        "href": '/page/ContactEmail',
        "icon": 'envelope',
        "label": 'Contattaci'
    },
    {
        "type": 'item',
        "href": '/page/CustomerMonitoring',
        "icon": 'chart-line',
        "label": 'Monitoraggio clienti',
        "hideForLevel": [1, 2, 9]
    },

    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Utente'
    },
    {
        "type": 'item',
        "href": '/settings',
        "icon": 'user-gear',
        "entity": '',
        "label": 'Profilo'
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'cogs',
        "entity": '',
        "label": 'Impostazioni',
        "items": [
            {
                "type": 'item',
                "href": '/entity/user',
                "entity": 'user',
                "label": 'Utenti'
            },
            {
                "type": 'item',
                "href": '/entity/user_group',
                "entity": 'user_group',
                "label": 'Gruppi'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_saved_filters',
                "entity": 'user_entity_saved_filters',
                "label": 'Filtri salvati'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_preferences',
                "entity": 'user_entity_preferences',
                "label": 'Preferenze entità'
            },
            {
                "type": 'item',
                "href": '/entity/family',
                "entity": 'family',
                "label": 'Famiglie di prodotti',
                "hideForLevel": [1, 2]
            },
        ]
    },
    {
        "type": 'item',
        "href": '/logout',
        "icon": 'arrow-right-from-bracket',
        "entity": '',
        "label": 'Logout'
    }
]